// extracted by mini-css-extract-plugin
module.exports = {"icon":"statusIcon_icon__mhG-A","selectedIcon":"statusIcon_selectedIcon__eNlvM"};